export function isValidEmail(email: string): boolean {
  const trimmedEmail = email.trim();

  if (!trimmedEmail) {
    return false;
  }

  return /^[^\s@;,]+@[^\s@;,]+\.[^\s@;,]+$/.test(trimmedEmail);
}

export function normalizeEmail(email: string): string {
  return email.trim().toLocaleLowerCase();
}